// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Austria from '../_raw/flag/icon_flag_austria.png';

export default () => <img src={Austria} alt="Austria" />;
